if ( !customElements.get( 'customization-options' ) ) {
    class CustomizationOptions extends HTMLElement {
        connectedCallback() {
            this.fieldsContainer = this.querySelector('[data-load-fields]');
            this.dataScript = this.querySelector('#customization-options-data');
            this.productData = this.dataScript ? JSON.parse(this.dataScript.textContent) : null;
            this.onVariantChange = this.onVariantChange.bind( this );
            this.onInput = this.onInput.bind(this);
            this.addEventListener( 'input', this.onInput );

            document.addEventListener( 'variant:changed', this.onVariantChange );

            this.initCharacterCounters();
        }

        disconnectedCallback() {
            document.removeEventListener( 'variant:changed', this.onVariantChange );
            this.removeEventListener( 'input', this.onInput );
        }

        onVariantChange( event ) {
            const variantId = event.detail?.variant?.id;

            if (!variantId || !this.productData) { 
                return;
            }

            const matchedVariant = this.productData.variants.find( ( variant ) => variant.id == variantId );

            if (!matchedVariant) { 
                return;
            }

            const templates = matchedVariant.config.map( ( field ) => field.template ).join( '' );
            this.fieldsContainer.innerHTML = null;
            this.fieldsContainer.innerHTML = templates;

            this.initCharacterCounters();
            document.dispatchEvent( new CustomEvent('customization-options:input') );
        }

        initCharacterCounters() {
            const fields = this.querySelectorAll( '.customizable-text-field__input[data-show-counter="true"]' );
            const fieldsLength = fields.length;

            for ( let index = 0; index < fieldsLength; index++ ) {
                const field = fields[ index ];
                const wrapper = field.closest( '.customizable-text-field' );

                if ( !wrapper ) {
                    continue;
                }

                const counter = wrapper.querySelector( '[data-character-counter]' );

                if ( !counter ) {
                    continue;
                }

                const limit = field.dataset.characterLimit || field.maxLength;

                if (field.value.length > 0) {
                    counter.textContent = `${field.value.length} / ${limit}`;
                } else {
                    counter.textContent = `Character limit: ${limit}`;
                }
            }
        }

        getFieldValues() {
            const fields = this.querySelectorAll( '.customizable-text-field__input' );
            const fieldsLength = fields.length;
            const data = {};

            for ( let index = 0; index < fieldsLength; index++ ) {
                const field = fields[ index ];
                const label = field.dataset.label;
                data[ label ] = field.value;
            }

            return data;
        }

        getVariantConfig( variantId ) {
            let config = null;

            if ( variantId && this.productData ) {
                const variants = this.productData.variants;
                const variantsLength = variants.length;

                for ( let index = 0; index < variantsLength; index++ ) {
                    const variant = variants[ index ];

                    if ( variant.id == variantId ) {
                        config = variant.config;
                        break;
                    }
                }
            }

            return config;
        }

        onInput() {
            this.initCharacterCounters();
            document.dispatchEvent( new CustomEvent('customization-options:input') );
        }
    }

    customElements.define( 'customization-options', CustomizationOptions );
}